/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Shubham Taral",
  title: "Hi all, I'm Shubham Taral",
  subTitle: emoji(
    "A Passionate DevOps Engineer 😎 specializing in Cloud Computing, CI/CD, and Automation. Experienced in architecting scalable infrastructure with Azure, GCP, Kubernetes, and Terraform optimizing deployments, enhancing system reliability, and driving seamless automation."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1vRfMQ8QQYjt-2bj9vX9C2B_eYsUyl12a/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/shubhamtaral",
  linkedin: "https://www.linkedin.com/in/shubham-taral/",
  gmail: "shubhamtaral007@gmail.com",
  // gitlab: "https://gitlab.com/shubhamtaral",
  facebook: "https://www.facebook.com/shutaral143",
  medium: "https://medium.com/@shubhamtaral007",
  // stackoverflow: "https://stackoverflow.com/users/10422806/shubhamtaral",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE DEVOPS ENGINEER WHO LOVES AUTOMATION & CLOUD TECHNOLOGIES",
  skills: [
    emoji("⚡ Architect and automate cloud infrastructure using Terraform, Helm, and Kubernetes for scalable, self-healing environments"),
    emoji("⚡ Design high-performance CI/CD pipelines that accelerate deployments and eliminate manual bottlenecks"),
    emoji("⚡ Build robust monitoring and logging systems with Prometheus, Grafana, and ELK Stack to ensure 24/7 observability"),
    emoji("⚡ Optimize cloud operations across Azure and GCP, leveraging best practices for cost efficiency and security"),
    emoji("⚡ Containerize everything! Transform monolithic applications into microservices using Docker & orchestrate with Kubernetes"),
    emoji("⚡ Seamlessly integrate third-party services like SonarCloud, automating workflows for a frictionless developer experience")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "terraform",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "kubernetes",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "jenkins",
      fontAwesomeClassname: "fas fa-cogs"
    },
    {
      skillName: "azure-devops",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "azure",
      fontAwesomeClassname: "fab fa-buysellads"
    },
    {
      skillName: "gcp",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "prometheus",
      fontAwesomeClassname: "fas fa-chart-line"
    },
    {
      skillName: "grafana",
      fontAwesomeClassname: "fas fa-chart-pie"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "MIT-SOM, Pune",
      logo: require("./assets/images/mitsomLogo.jpg"),
      subHeader: "Master of Computer Applications (MCA)",
      duration: "2016 - 2019",
      desc: "Focused on software development, cloud computing, and DevOps methodologies.",
      descBullets: [
        "Gained expertise in software architecture and automation",
        "Worked on cloud platforms like Azure and GCP"
      ]
    },
    {
      schoolName: "Leelawati College, Pune",
      logo: require("./assets/images/leelawatiLogo.jpg"),
      subHeader: "Bachelor of Computer Applications (BCA)",
      duration: "2012 - 2015",
      desc: "Developed strong foundational knowledge in programming, databases, and networking.",
      descBullets: [
        "Learned programming languages like JavaScript, Python, and Shell scripting",
        "Worked on database management with PostgreSQL, MSSQL, and MongoDB"
      ]
    },
    // {
    //   schoolName: "VIVA College, Virar(W)",
    //   logo: require("./assets/images/vivaLogo.png"),
    //   subHeader: "Higher Secondary Certificate (HSC)",
    //   duration: "2012",
    //   desc: "Completed coursework in mathematics, computer science, and logical reasoning."
    // },
    // {
    //   schoolName: "Utkarsha Vidyalaya, Virar(W)",
    //   logo: require("./assets/images/utkarshaLogo.png"),
    //   subHeader: "Secondary School Certificate (SSC)",
    //   duration: "2010",
    //   desc: "Achieved strong academic performance in foundational subjects."
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Cloud Platforms (Azure, GCP)",
      progressPercentage: "70%"
    },
    {
      Stack: "Infrastructure as Code (Terraform, Helm, Ansible)",
      progressPercentage: "85%"
    },
    {
      Stack: "CI/CD Pipelines (Jenkins, GitLab CI/CD, Azure DevOps)",
      progressPercentage: "80%"
    },
    {
      Stack: "Containerization & Orchestration (Docker, Kubernetes)",
      progressPercentage: "70%"
    },
    {
      Stack: "Monitoring & Logging (Prometheus, Grafana, ELK Stack)",
      progressPercentage: "75%"
    },
    {
      Stack: "Scripting & Automation (Python, Shell, PowerShell)",
      progressPercentage: "85%"
    },
    {
      Stack: "Database Management (PostgreSQL, MSSQL, MongoDB)",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    // {
    //   role: "Sr. Analyst - DevOps",
    //   company: "CRISIL",
    //   companylogo: require("./assets/images/crisilLogo.png"),
    //   date: "March 2025 - Present",
    //   desc: "Joining as a Sr. Analyst in the DevOps team, focusing on cloud infrastructure, automation, and CI/CD processes.",
    //   // descBullets: [
    //   //   "Designing scalable DevOps solutions for cloud environments.",
    //   //   "Enhancing CI/CD pipelines for improved efficiency.",
    //   //   "Implementing security best practices for infrastructure and deployments.",
    //   //   "Working on cloud cost optimization and performance tuning."
    //   // ]
    // },
    {
      role: "Sr. DevOps Automation Engineer",
      company: "ContractPod Technologies Ltd",
      companylogo: require("./assets/images/contractpodLogo.png"),
      date: "Aug 2021 - Feb 2025",
      desc: "Leading DevOps initiatives, automating infrastructure, and improving CI/CD workflows.",
      descBullets: [
        "Advised and architected automated infrastructure provisioning using Terraform.",
        "Designed CI/CD pipelines for Azure WebApps & Functions, cutting deployment time.",
        "Engineered secure, scalable cloud networking with custom VPNs, Load Balancers, and Firewalls.",
        "Developed Kubernetes deployment strategies with Helm, reducing downtime and improving scalability.",
        "Led production support and conducted hands-on DevOps workshops."
    ]    
    },
    {
      role: "DevOps Engineer",
      company: "American Portfolios Financial Services",
      companylogo: require("./assets/images/americanPortfoliosLogo.png"),
      date: "Feb 2019 - July 2021",
      desc: "Developed and maintained cloud infrastructure and automation pipelines.",
      descBullets: [
        "Designed Portfolio Insight using a scalable Microservices Architecture.",
        "Developed a high-performance API server in NodeJS, containerized with Docker.",
        "Built and optimized CI/CD pipelines using GitLab CI/CD for seamless deployments.",
        "Implemented a RabbitMQ cluster to streamline inter-service communication.",
        "Integrated Fluentd, Filebeat, and ELK Stack for real-time monitoring & logging.",
        "Automated infrastructure provisioning with Terraform and Ansible."
    ]
    },
    // {
    //   role: "Software Developer Trainee",
    //   company: "Giggada Technologies Pvt. Ltd.",
    //   companylogo: require("./assets/images/giggadaLogo.png"),
    //   date: "Internship",
    //   desc: "Gained hands-on experience in software development and DevOps practices."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me 📩"),
  subtitle:
    "Want to discuss DevOps, Cloud, or Automation? Feel free to reach out!",
  // number: "+92-0000000000",
  email_address: "letsconnect@shubhamtaral.in"
};

// Twitter Section

const twitterDetails = {
  userName: "Shubham_Taral", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
